import React from 'react'

// Cabecera compartida por los cuatro modales (dos por página): nombre de la
// contraparte y, sólo en los saldos heredados, la línea que dice de qué
// sistema viene.
export default function TargetCaption({ target, style }) {
  return (
    <p style={{ color: 'var(--text-muted)', fontSize: 13, ...style }}>
      {target.title}
      {target.subtitle && (
        <><br /><span style={{ fontSize: 12 }}>{target.subtitle}</span></>
      )}
    </p>
  )
}
